import cloneDeep from 'lodash.clonedeep';

import form from './form';
import modal from './modal';

const modalForm = modal.make();

modalForm.form = form.make();

modalForm.form.getSubmitButton = function() {
  return this.modal.el.querySelector('button[type=submit]');
};

const superRender = modalForm.render;
modalForm.render = function() {
  const renderForm = () => {
    this.form.modal = this;
    this.form.container = this.el.querySelector('.content');
    return this.form.render();
  };
  return superRender.call(this)
    .then(renderForm);
};

const make = cloneDeep.bind(null, modalForm);

export default {
  make,
};
